//@ts-nocheck
import React from 'react';
import dayjs from 'dayjs'
import { showDate, showDateTime, showDateTimeUTC, showDateUTC, showTime, showTimeUTC } from './Helpers';
import { authEndpoints, endpoints } from './Constants';
import { createCharterRequestYup, clientDepartmentShapeYup, clientStaffShapeYup, charterRequestManifestShapeYup, placeBidShapeYup, clientShapeYup, resetPasswordShapeYup, supplierShapeYup, aircraftImageShapeYup, aircraftShapeYup, adminShapeYup, allowedActionsShapeYup, newEmailShapeYup } from './YupShapes';
import { ViewMessageLogItem } from '../components/EntityList/ViewMessageLog';
import ClientEditor from '../components/TabbedEntity/ClientEditor';
import ResetPassword from '../components/Editors/ResetPassword';
import CharterRequest from '../components/TabbedEntity/CharterRequest';
import { Row, Container } from 'reactstrap';
import GetRemaining from '../components/Editors/GetRemaining';
import EditSupplier from '../components/TabbedEntity/EditSupplier';
import AircraftImageDetail from '../components/Editors/AircraftImageDetail';
import AircraftDetail from '../components/Editors/AircraftDetail';
import ClientDepartmentEditor from '../components/TabbedEntity/ClientDepartmentEditor';
import CharterRequestDetail from '../components/Editors/CharterRequestDetail';
import DocumentDetails from '../components/Editors/DocumentDetails';
import ClientStaffDetail from '../components/Editors/ClientStaffDetail';
import ClientStaffEditor from '../components/TabbedEntity/ClientStaffEditor';
import MarginEditor from '../components/Editors/MarginEditor';
import AdminDetail from '../components/Editors/AdminDetail';
import CharterAdminDetail from '../components/Editors/CharterAdminDetail';
import JobReference from '../components/Editors/JobReference';
import ViewPdf from '../components/Editors/ViewPdf';
import MoveDepartmentToStaff from '../components/Pages/ManageClients/MoveDepartmentToStaff';
import MoveClientToDepartment from '../components/Pages/ManageClients/MoveClientToDepartment';
import MoveStaffToSupplier from '../components/Pages/ManageClients/MoveStaffToSupplier';
import AllowedActionDetail from '../components/Editors/AllowedActionDetail';
import StateChangeEventDetail from '../components/Editors/StateChangeEventDetail';
import CharterShare from '../components/Editors/CharterShare';
import { newShareCharter } from './Shapes';
import UserStatus from '../components/Editors/UserStatus';
import Manifest from '../components/Editors/Manifest';
import moment from 'moment';
import prepareForEdit from './entities/charterRequest';
import ExcelExport from '../components/Excel/ExcelExport';
import PayLoadReportExport from '../components/Excel/PayLoadReportExport';
import ChangeEmail from '../components/Editors/ChangeEmail';
import TimeLineEntity from '../components/Editors/TimeLineEntity';
import EmailSuppliers from '../components/Editors/EmailSuppliers';
import SecondaryEmails from '../components/EntityList/SecondaryEmails';
import { ISupplierDocument } from "../Models/ISupplierDocument";
import CloneCharterRequestDetail from '../components/Editors/CloneCharterRequestDetail';
import { date } from 'yup';


const prepareChange = ({ routes, supplierId, original, ...rest }) => {
    return {
        original: prepareForEdit(original),
        bid: { ...rest },
        ...rest,
        routes: routes?.map((x, i) => {
            var date = moment(x.departTime);
            const newRoute = {
                ...x
                , viewDepartTime: date
                , viewDepartDate: new Date(x.departTime)
                , passengerRange_Max: x.passengerRange_Max ? x.passengerRange_Max : x.passengerNumber
                , passengerRange_Min: x.passengerRange_Min ? x.passengerRange_Min : x.passengerNumber

            }

            return { ...newRoute, id: x.id };
        }),
        supplierInitiated: true,
        supplierId,
        bidderId: supplierId,
    }
};
const prepareChangeSave = ({ routes, supplierId, original, ...rest }) => {
    return {
        ...rest,
        routes: routes?.map((x, i) => {
            var date = moment(x.departTime);
            const newRoute = {
                ...x
                , viewDepartTime: date
                , viewDepartDate: new Date(x.departTime)
                , passengerRange_Max: x.passengerRange_Max ? x.passengerRange_Max : x.passengerNumber
                , passengerRange_Min: x.passengerRange_Min ? x.passengerRange_Min : x.passengerNumber

            }

            return { ...newRoute, id: x.id };
        }),

        supplierId,
        bidderId: supplierId,
    }
};

const entities =
{
    charterRequest: {
        name: 'CharterRequest',
        title: 'Charter Request',
        plural: 'Charter Requests',
        getSingle: endpoints.getCharterRequest,
        saveSingle: endpoints.updateCharterRequest,
        getTitle: (charterRequest) => <JobReference big charter={charterRequest} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        columns: [
            { accessor: 'request.status', Header: 'Status' },
            {
                accessor: (x) => x.request.jobReference,
                Cell: ({ row }) => <JobReference charter={row.original} />,
                Header: 'Job Reference',

            },
            {
                accessor: (x) => x.departTime,
                Cell: ({ row }) => { return showDate(row.original.departTime) + '\n' + showTime(row.original.departTime) },
                Header: 'Depart Time',

            },
            {
                accessor: 'from',
                Header: 'From',

            },
            {
                accessor: 'to',
                Header: 'To',

            },
            {
                accessor: (x) => <GetRemaining charter={x} />,
                Header: 'Remaining',

            },
            {
                accessor: 'routeCount',
                Header: 'Sectors',

            },
            { accessor: 'bidCount', Header: 'Bids' },

        ],
        editor: (props) => <CharterRequest {...props} />,
        prepareForEdit: (x) => prepareForEdit(x, false),
        validationSchema: createCharterRequestYup,
        saveMessage: (charter) => <h3>Updated JB{charter.jobReference} </h3>,
        beforeSave: (values) => {

            let { routes, ...rest } = values;
            let ret = rest;

            if (values.activeTab === 'Return') {
                routes[1].to = routes[0].from;
                routes[1].from = routes[0].to;
            }
            if (values.activeTab === 'OneWay') {
                const route = routes[0];
                routes = [route];
            }
            ret.routes = routes ? routes.map(x => {
                const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
                const departTime = dayjs(departTimeStr);
                const dateStart = departTime.format('YYYY-MM-DDTHH:mm:ss');
                if (!x.passengerRange) {
                    x.passengerRange_Min = 0;
                    x.passengerRange_Max = 0;
                }

                x.departTime = dateStart;
                return x;
            }) : null;
            ret.changeCharterRequestId = '00000000-0000-0000-0000-000000000000';

            return ret;
        },
        excelDownload: true,
        seconadaryEntity: { name: 'Bid', value: 'bid' }
    },
    manifest: {
        name: 'Manifest',
        title: 'Manifest',
        plural: 'Manifest',
        getSingle: endpoints.getCharterRequest,
        saveSingle: endpoints.updateManifest,
        addSingle: endpoints.updateManifest,
        getTitle: (charterRequest) => <JobReference big manifest charter={charterRequest} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        columns: [
            { accessor: 'request.status', Header: 'Status' },
            {
                accessor: (x) => x.request.jobReference,
                Cell: ({ row }) => <JobReference charter={row.original} />,
                Header: 'Job Reference',

            },
            {
                accessor: (x) => x.departTime,
                Cell: ({ row }) => { return showDate(row.original.departTime) + '\n' + showTime(row.original.departTime) },
                Header: 'Depart Time',

            },
            {
                accessor: 'from',
                Header: 'From',
                sortNoCase: true,
            },
            {
                accessor: 'to',
                Header: 'To',
                sortNoCase: true,
            },
            {
                accessor: (x) => <GetRemaining charter={x} />,
                Header: 'Remaining',

            },
            {
                accessor: 'routeCount',
                Header: 'Sectors',

            },
            { accessor: 'bidCount', Header: 'Bids' },

        ],
        editor: (props) => <Manifest {...props} />,
        validationSchema: charterRequestManifestShapeYup,
        saveMessage: (charter) => <h3>Updated JB{charter.jobReference} </h3>,
        beforeSave: (values) => {

            let { routes, ...rest } = values;
            let ret = rest;

            if (values.activeTab === 'Return') {
                routes[1].to = routes[0].from;
                routes[1].from = routes[0].to;
            }
            if (values.activeTab === 'OneWay') {
                const route = routes[0];
                routes = [route];
            }
            ret.routes = routes ? routes.map(x => {

                const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
                const departTime = dayjs(departTimeStr);
                const dateStart = departTime.format('YYYY-MM-DDTHH:mm:ss');
                x.departTime = dateStart;
                x.manifest = x.manifest?.map((y) => {
                    y.passengerWeight = parseInt(y.passengerWeight ? y.passengerWeight : '0');
                    y.freightWeight = parseInt(y.freightWeight ? y.freightWeight : '0');
                    y.cargoWeight = parseInt(y.cargoWeight ? y.cargoWeight : '0');
                    return y;
                });
                return x;
            }) : null;

            return ret;
        },

    },
    placeBid: {
        name: 'Bid',
        title: 'Place Bid',
        plural: 'Place Bids',
        prepareForEdit: (charterRequest) => {
            const s = { status: 'New' };
            const { jobReference, id, ...request } = charterRequest;
            const bidderId = '';
            const price = 0;
            const currency = 'AUD';
            const bidRoute = request.routes.map(x => {
                const bid = {
                    passengerLimit: 0,
                    fromAirport: '',
                    toAirport: '',
                    payload: 0,
                    flightTime: '',
                    aircraft: [],
                };
                return { ...x, ...bid };
            });
            const req = { ...request, routes: bidRoute }

            const newBid = {
                charterRequestId: req.id,
                ...req, ...s, bidderId, price, currency, jobReference, id: req.id, bid: {}, sameAircraft: true,
            };
            return newBid;

        },
        addSingle: endpoints.newbid,
        getSingle: endpoints.getCharterRequest,
        getTitle: (charterRequest) => {
            return charterRequest?.jobReference
        },
        saveMessage: (charter) => <h3>Thank you, you have just placed a bid on Job Number JB{charter.jobReference} </h3>
        ,
        defaultStatus: 'Pending',
        asNewItem: true,
        beforeSave: ({ routes, ...rest }) => {
            return {
                ...rest, routes: routes.map(x => {

                    const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
                    const departTime = dayjs(departTimeStr);
                    const dateStart = departTime.format('YYYY-MM-DDTHH:mm:ss');
                    x.departTime = dateStart;
                    return x;
                })
            }
        },
        editor: (props) => <CharterRequestDetail {...props} edit={true} noEdit placeBid />,
        validationSchema: placeBidShapeYup

    },
    supplierBid: {
        name: 'Bid',
        plural: 'Bids',
        title: 'Offer',
        hideStatus: true,
        getSingle: endpoints.getCharterRequestByBidId,
        prepareForEdit: (x) => prepareForEdit(x, true),
        saveSingle: endpoints.newbid,
        itemParam: 'bidId',
        getByStatus: ({ id }) => {
            return endpoints.getCharterRequestBids + id;
        },
        getTitle: (detail) => {
            return "Offer - JB" + detail.jobReference + ' (' + detail.status + ')';
        },
        defaultStatus: 'Pending',
        heightOffset: 0,

        columns: [
            {
                accessor: (x) => x.jobReference,
                Cell: ({ row }) => {
                    return <JobReference charter={row.original} />
                },
                Header: 'Job Reference',

            },
            {
                accessor: (x) => x.timeOfBid,
                Cell: ({ row }) => showDateTimeUTC(row.original?.timeOfBid),
                Header: 'Time of Bid'
            },
            {
                accessor: (x) => x.rank,
                Cell: ({ row }) => row.original?.price ? '(' + row.original?.rank + ') - $' + row.original?.currency + row.original.price.toLocaleString() : '(' + row.original?.rank + ')',
                Header: '(Rank) Price'
            },
            { accessor: (x) => x.status, Header: 'Status' },
        ],
        editor: (props) => <CharterRequestDetail {...props} edit={true} noEdit={true} placeBid />


        ,
        validationSchema: placeBidShapeYup
    },
    supplierBidSupplierVisibile: {
        name: 'Bid',
        plural: 'Bids',
        title: 'Offer',
        hideStatus: true,
        getSingle: endpoints.getCharterRequestByBidId,
        prepareForEdit: (x) => prepareForEdit(x, true),
        saveSingle: endpoints.newbid,
        itemParam: 'bidId',
        getByStatus: ({ id }) => {
            return endpoints.getCharterRequestBids + id;
        },
        getTitle: (detail) => {
            return "Offer - JB" + detail.jobReference + ' (' + detail.status + ')';
        },
        defaultStatus: 'Pending',
        heightOffset: 0,

        columns: [
            {
                accessor: (x) => x.jobReference,
                Cell: ({ row }) => {
                    return <JobReference charter={row.original} />
                },
                Header: 'Job Reference',
            },
            {
                accessor: (x) => x.supplier.companyName,
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original?.supplier?.companyName} </b></Row >
                    </Container>
                </UserStatus>,
                Header: 'Supplier',
                sortNoCase: true,
            },
            {
                accessor: (x) => x.bid?.timeOfBid,
                Cell: ({ row }) => showDateTimeUTC(row.original?.timeOfBid),
                Header: 'Time of Bid'
            },
            {
                accessor: (x) => x.rank,
                Cell: ({ row }) => row.original?.price ? '(' + row.original?.rank + ') - $' + row.original?.currency + row.original?.price.toLocaleString() : '(' + row.original?.rank + ')',
                Header: '(Rank) Price'
            },
            { accessor: (x) => x.status, Header: 'Status' },
        ],
        editor: (props) => <CharterRequestDetail {...props} edit={true} noEdit={true} placeBid />


        ,
        validationSchema: placeBidShapeYup
    },
    supplierBidClient: {
        name: 'Bid',
        plural: 'Bids',
        title: 'Supplier Bid',
        getSingle: endpoints.getCharterRequestByBidId,
        prepareForEdit: (x) => prepareForEdit(x, true),
        saveSingle: null,
        itemParam: 'itemId',
        parentParam: 'supplierId',
        hideStatus: true,
        getByStatus: ({ id }) => {
            return endpoints.getSupplierBids + (id ? id : '00000000-0000-0000-0000-000000000000');
        },
        getTitle: (detail) => {
            return "Offer - JB" + detail.jobReference + ' (' + detail.status + ')';
        },
        defaultStatus: 'Active',
        heightOffset: 0,

        columns: [
            {
                accessor: (x) => x.client,
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original.client?.companyName} </b></Row >
                        <Row>{row.original.clientDepartment?.departmentName} </Row></Container >
                </UserStatus>,
                Header: 'Client',
                sortNoCase: true,
            },
            {
                accessor: (x) => x.request?.from + "->" + x.request?.to + ' ' + showDateTime(x.departTime)
                , Header: 'Route'
            },
            {
                accessor: (x) => x.bid.timeOfBid,
                Cell: ({ row }) => showDateTimeUTC(row.original?.bid.timeOfBid),
                Header: 'Time of Bid'
            },
            {
                accessor: (x) => x.rank,
                Cell: ({ row }) => row.original?.bid?.price ? '(' + row.original?.rank + ') - $' + row.original?.bid?.currency + row.original.bid?.price.toLocaleString() : '(' + row.original?.rank + ')',
                Header: '(Rank) Price'
            },
            { accessor: (x) => x.bid.status, Header: 'Status' },
        ]
        ,
        validationSchema: placeBidShapeYup

    },
    supplierBidClientSupplierVisible: {
        name: 'Bid',
        plural: 'Bids',
        title: 'Supplier Bid',
        getSingle: endpoints.getCharterRequestByBidId,
        prepareForEdit: (x) => prepareForEdit(x, true),
        saveSingle: null,
        itemParam: 'itemId',
        parentParam: 'supplierId',
        hideStatus: true,
        getByStatus: ({ id }) => {
            return endpoints.getSupplierBids + (id ? id : '00000000-0000-0000-0000-000000000000');
        },
        getTitle: (detail) => {
            return "Offer - JB" + detail.jobReference + ' (' + detail.status + ')';
        },
        defaultStatus: 'Active',
        heightOffset: 0,

        columns: [
            {
                accessor: (x) => x.client.companyName,
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original.client?.companyName} </b></Row >
                        <Row>{row.original?.clientDepartment?.departmentName} </Row></Container >
                </UserStatus>,
                Header: 'Client',
                sortNoCase: true,
            },
            {
                accessor: (x) => x.supplier.companyName,
                Cell: ({ row }) => <UserStatus client={row.original.client}>
                    <Container><Row><b>{row.original?.supplier?.companyName} </b></Row >
                    </Container>
                </UserStatus>,
                Header: 'Supplier',
                sortNoCase: true,
            },
            {
                accessor: (x) => x.request?.from + "->" + x.request?.to + ' ' + showDateTime(x.departTime)
                , Header: 'Route'
            },
            {
                accessor: (x) => x.timeOfBid,
                Cell: ({ row }) => showDateTimeUTC(row.original?.timeOfBid),
                Header: 'Time of Bid'
            },
            {
                accessor: (x) => x.rank,
                Cell: ({ row }) => row.original?.price ? '(' + row.original?.rank + ') - $' + row.original?.currency + row.original.price.toLocaleString() : '(' + row.original?.rank + ')',
                Header: '(Rank) Price'
            },
            { accessor: (x) => x.bid.status, Header: 'Status' },
        ]
        ,
        validationSchema: placeBidShapeYup

    },
    charterShare: {
        name: 'CharterShare',
        title: 'Charter Share',
        plural: 'Charter Shares',
        getSingle: endpoints.getCharterShare,
        saveSingle: endpoints.updateCharterShare,
        addSingle: endpoints.updateCharterShare,
        getTitle: (charterRequest) => <JobReference share big charter={charterRequest} />,
        params: ["charterRequestId", "activeKey"],

        defaultStatus: 'Pending',
        editor: (props) => <CharterShare {...props} />,
        prepareForEdit: (x) => {
            return x.isCharterRequest ? { ...x, status: x.routes[0].share?.status ? x.routes[0].share.status : 'Pending', charterRequestId: x.id, id: null } : ({ ...x, status: x.share.status, id: x.share.id, routes: [{ ...x.route, ...x.route.bidRoute, share: x.share }] })
        },
        saveMessage: (charter) => <h3>Updated Share for JB{charter.request.jobReference} </h3>,
        beforeSave: (values) => {
            return { ...values, id: values.id ? values.id : values.charterRequestId };
        },

    },
    cloneCharterRequest: {
        name: 'CloneCharterRequest',
        title: 'Clone Charter Request',
        plural: 'Clone Charter Requests',
        getSingle: endpoints.getChangeCharter,
        saveSingle: endpoints.cloneCharterRequest,
        addSingle: endpoints.cloneCharterRequest,
        getTitle: (changeCharter) => <JobReference big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CloneCharterRequestDetail newRequest compare {...props} edit={true} />
        },
        validationSchema: createCharterRequestYup,
        prepareForEdit: ({ id, ...x }) => {

            x.routes = x.routes ? x.routes.map(x => {
                //x.departTime = ''
               // x.departTimeUI = ''
                x.flightTime = null
                x.viewDepartDate = ''
                //x.viewDepartTime=''
                return x
            }) : null
            x.bid = null
            x.bids = null
            x.bidderId = ''
            x.bidCount = 0
            x.bidExpiredAt = null
            x.biddingEndsAt = null
            x.biddingTimeSpanHours=120          
            x.timeOfBid = null
            x.supplier = null

            return { ...x, status: '', supplierInitiated: false }
        },
        saveMessage: (jobReference) => {
            return <h3>Created new job JB{jobReference} </h3>
        },
        beforeSave: ({ routes, ...rest }) => {         
             
            return {
                ...rest, routes: routes.map(x => {
                    //if (x.viewDepartDate && x.viewDepartTime) {
                        x.viewDepartTime=x.viewDepartTime?x.viewDepartTime: dayjs(new Date().toLocaleDateString())
                        x.viewDepartDate=x.viewDepartDate?x.viewDepartDate:dayjs(new Date().toLocaleDateString());

                        const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
                        const departTime = dayjs(departTimeStr);
                        const dateStart = departTime?.format('YYYY-MM-DDTHH:mm:ss');
                        x.departTime = dateStart;
                    //}

                    return x;
                })
            }
        },
    },
    changeCharterClient: {
        name: 'ChangeCharter',
        title: 'Change Charter',
        plural: 'Change Charters',
        getSingle: endpoints.getChangeCharter,
        saveSingle: endpoints.updateChangeCharter,
        addSingle: endpoints.addChangeCharter,
        getTitle: (changeCharter) => <JobReference change big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CharterRequestDetail compare {...props} />
        },
        prepareForEdit: ({ id, ...x }) => {
            return { ...x, status: 'New', supplierInitiated: false }
        },
        saveMessage: (charter) => <h3>Updated Change for JB{charter.request.jobReference} </h3>,
        beforeSave: ({ routes, ...rest }) => {
            return {
                ...rest, routes: routes.map(x => {

                    const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
                    const departTime = dayjs(departTimeStr);
                    const dateStart = departTime.format('YYYY-MM-DDTHH:mm:ss');
                    x.departTime = dateStart;
                    return x;
                })
            }
        },
    },
    changeCharterSupplier: {
        name: 'ChangeCharter',
        title: 'Change Charter',
        plural: 'Change Charters',
        getSingle: endpoints.getChangeCharter,
        saveSingle: endpoints.updateChangeCharter,
        addSingle: endpoints.addChangeCharter,
        getTitle: (changeCharter) => <JobReference change big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CharterRequestDetail compare placeBid supplierChange {...props} />
        },
        prepareForEdit: ({ id, ...x }) => {
            return { ...x, status: 'New', supplierInitiated: true }
        },
        saveMessage: (charter) => <h3>Updated Change for JB{charter.request.jobReference} </h3>,
        beforeSave: ({ routes, ...rest }) => {
            return {
                ...rest, routes: routes.map(x => {

                    const departTimeStr = dayjs(x.viewDepartDate).format('YYYY-MM-DD') + ' ' + x.viewDepartTime.format('HH:mm:ss');
                    const departTime = dayjs(departTimeStr);
                    const dateStart = departTime.format('YYYY-MM-DDTHH:mm:ss');
                    x.departTime = dateStart;
                    return x;
                })
            }
        },


    },
    changeCharterResponseClient: {
        name: 'ChangeCharter',
        title: 'Change Charter',
        plural: 'Change Charters',
        getSingle: endpoints.getChangeCharter,
        saveSingle: endpoints.updateChangeCharter,
        getTitle: (changeCharter) => <JobReference change big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CharterRequestDetail compare {...props} />
        },
        prepareForEdit: prepareChange,
        saveMessage: (charter) => <h3>Updated Change for JB{charter.request.jobReference} </h3>,
        beforeSave: prepareChangeSave,
    },
    changeCharterResponseSupplier: {
        name: 'ChangeCharter',
        title: 'Change Charter',
        plural: 'Change Charters',
        getSingle: endpoints.getChangeCharter,
        addSingle: endpoints.updateChangeCharter,
        getTitle: (changeCharter) => <JobReference change big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CharterRequestDetail compare placeBid {...props} />
        },
        saveMessage: (charter) => <h3>Updated Change for JB{charter.request.jobReference} </h3>,
        beforeSave: prepareChangeSave,
        prepareForEdit: null,
    },
    changeCharter: {
        name: 'ChangeCharter',
        title: 'Change Charter',
        plural: 'Change Charters',
        getSingle: endpoints.getChangeCharter,
        saveSingle: endpoints.updateChangeCharter,
        addSingle: endpoints.addChangeCharter,
        getTitle: (changeCharter) => <JobReference change big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CharterRequestDetail compare placeBid supplierChange {...props} />
        },
        prepareForEdit: prepareChange,
        fetchItemId: () => 'changePending',
        saveMessage: (charter) => <h3>Updated Change for JB{charter.request.jobReference} </h3>,
        beforeSave: prepareChangeSave,

    },
    viewChangeCharter: {
        name: 'ChangeCharter',
        title: 'Change Charter',
        plural: 'Change Charters',
        getSingle: endpoints.getChangeCharter,
        saveSingle: endpoints.updateChangeCharter,
        addSingle: endpoints.updateChangeCharter,
        getTitle: (changeCharter) => <JobReference change big charter={changeCharter} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => {
            return <CharterRequestDetail compare placeBid supplierChange {...props} />
        },
        prepareForEdit: prepareChange,
        fetchItemId: () => 'changePending',
        saveMessage: (charter) => <h3>Updated Change for JB{charter.request.jobReference} </h3>,
        beforeSave: prepareChangeSave,

    },
    timeline: {
        name: 'Timeline',
        title: 'Timeline',
        plural: 'Timeline',
        getByStatus: ({ type, id }) => endpoints.getTimeline + type + '/' + id,
        getTitle: "Timeline",
        hideActions: true,
        hideNew: true,
        hideViewButton: true,
        supplierColumn: { accessor: 'supplier.companyName', Header: 'Supplier' },
        clientColumn:
        {
            accessor: (x) => x.client,
            Cell: ({ row }) => <UserStatus client={row.original.client}>
                <Container><Row><b>{row.original.client?.companyName} </b></Row >
                    <Row>{row.original.clientDepartment?.departmentName} </Row></Container >
            </UserStatus>,
            Header: 'Client',
        },
        charterColumn: {
            accessor: (x) => x.request?.jobReference,
            Cell: ({ row }) => <JobReference charter={row.original.request} />,
            Header: 'Job Reference',

        },
        columns: [
            {
                accessor: (x) => x.timeStamp,
                Cell: ({ row }) => showDateUTC(row.original.timeStamp) + '\n' + showTimeUTC(row.original.timeStamp),
                Header: 'Created'
            },
            {
                accessor: 'entity', Header: 'Item', Cell: ({ row }) => <TimeLineEntity item={row.original} />
            },
            { accessor: 'newStatus', Header: 'New Status' },

        ],
    },
    charterSharePurchase: {
        name: 'CharterSharePurchase',
        title: 'Purchase Charter Share',
        plural: 'Purchase Charter Shares',
        getSingle: endpoints.getCharterSharePurchase,
        saveSingle: endpoints.updateCharterSharePurchase,
        addSingle: endpoints.updateCharterSharePurchase,
        getTitle: (charterRequest) => <JobReference share big charter={charterRequest} />,
        params: ["charterRequestId", "activeKey"],
        defaultStatus: 'Pending',
        editor: (props) => <CharterShare purchase {...props} />,
        prepareForEdit: (x) => {
            return { ...x, status: x.purchase ? x.purchase.status : 'New', id: x.purchase?.id, purchases: [x.purchase ? x.purchase : { ...newShareCharter }], routes: [{ ...x.route, ...x.route.bidRoute, share: x.share }] }
        },

        saveMessage: (charter) => {
            return charter.id ? <h3>Updated Share for JB{charter.request.jobReference} </h3> : <h3>You have just purchased a new Charter Share. We will confirm your purchase shortly.</h3 >
        },
        beforeSave: (values) => {


            return values;
        },


    },
    resetPassword: {
        title: 'Reset Password',
        name: 'User',
        addSingle: endpoints.resetPassword,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ResetPassword {...props} />,
        newItem: () => {
            return { password: '', checkPassword: '' };
        },
        validationSchema: resetPasswordShapeYup,
        prepareForEdit: (parent, item) => {
            return {
                ...parent, id: parent.aspNetUserId, password: '', checkPassword: ''
            }
        }
    },
    changeEmail: {
        title: 'Change Email',
        name: 'User',
        addSingle: endpoints.changeEmail,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ChangeEmail {...props} />,
        newItem: () => {
            return { newEmail: '' };
        },
        validationSchema: newEmailShapeYup,
        prepareForEdit: (parent) => {
            return {
                ...parent, id: parent.aspNetUserId, newEmail: '',
            }
        }
    },
    selectSuppliers: {
        title: 'Send Bulk Email',
        name: 'Suppliers',
        addSingle: endpoints.sendEmails,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: () => "",
        editor: (props) => <EmailSuppliers {...props} />,
        newItem: () => {
            return { newEmail: '' };
        },
        validationSchema: newEmailShapeYup,
        prepareForEdit: (parent) => {
            return {
                ...parent, supplierIds: [],
            }
        }
    },
    resetUserPassword: {
        title: 'Reset Password',
        name: 'User',
        addSingle: authEndpoints.resetUserPassword,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ResetPassword user {...props} hide={false} />,
        newItem: () => {
            return { password: '', originalPassword: '' };
        },
        validationSchema: resetPasswordShapeYup,
        prepareForEdit: (parent, item) => {
            return {
                ...parent, id: parent.aspNetUserId, password: '', checkPassword: ''
            }
        }
    },
    itineraryPdf: {
        title: 'Itinerary',
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ViewPdf pdfType='Itinerary' {...props} />,
    },
    payLoadReport: {
        title: 'Payload Report',
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <PayLoadReportExport exportType='PayloadReport' {...props} />,
    },
    // departureReport entity temporarily disabled due to removal of DepartureReportExport component.
    // To reinstate, recreate component and restore this block.
    downloadExcel: {
        title: 'Charter Requests',
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ExcelExport exportType='charterRequests' {...props} />,
    },
    supplierUnavailable: {
        title: 'Unavailable',
        defaultStatus: 'Active',
        heightOffset: 100,
        addSingle: endpoints.charterAvailable,
        beforeSave: (item) => {
            return { status: "Unavailable", charterRequestId: item.id }
        },
        getTitle: (item) => item.fullName,
        editor: (props) => <h6>Save to mark this charter as unavailable</ h6 >,
        saveMessage: () => <h4>This charter has been marked as Aircraft Unavailable </h4>,
    },
    supplierAvailable: {
        title: 'Available',
        defaultStatus: 'Active',
        heightOffset: 100,
        addSingle: endpoints.charterAvailable,
        beforeSave: (item) => {
            return {
                status: "Available", charterRequestId: item.id
            }
        },
        getTitle: (item) => item.fullName,
        editor: (props) => <h6>Save to mark this charter as available</ h6 >,
        saveMessage: () => <h4>We have removed the Aircraft Unavailable tag for you.</h4>,
    },
    clientEmail: {
        title: 'Client Email',
        getSingle: endpoints.getClientEmail,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ExcelExport exportType='jobTracker' {...props} />,
    },
    supplierEmail: {
        title: 'Supplier Email',
        getSingle: endpoints.getSupplierEmail,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ExcelExport exportType='jobTracker' {...props} />,
    },
    bidHistoryPdf: {
        title: 'Bid History',
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <ViewPdf pdfType='bidHistory' {...props} />,
    },
    moveClientToDepartment: {
        title: 'Move Client To Department',
        addSingle: endpoints.moveClientToDepartment,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <MoveClientToDepartment pdfType='bidHistory' {...props} />,
        newItem: () => {
            return { password: '', checkPassword: '' };
        },
        validationSchema: clientDepartmentShapeYup,
        prepareForEdit: (item) => {
            const departmentName = item?.companyName;
            const departmentDescription = item?.companyAddress + ' Phone : ' + item?.companyPhone;
            const departmentPhone = item?.companyPhone;
            return {
                ...item, clientMasterId: '', departmentName, departmentDescription, departmentPhone,
            }
        }
    },
    moveDepartmentToStaff: {
        title: 'Move Department To Staff',
        addSingle: endpoints.moveDepartmentToStaff,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <MoveDepartmentToStaff pdfType='bidHistory' {...props} />,
        validationSchema: clientStaffShapeYup,
        prepareForEdit: (item) => {
            return { ...item, clientDepartmentId: '', id: item.aspNetUserId, password: '', checkPassword: '', phoneNumber: item.departmentPhone }
        }
    },
    moveStaffToSupplier: {
        title: 'Move Staff To Supplier',
        addSingle: endpoints.moveStaffToSupplier,
        defaultStatus: 'Active',
        heightOffset: 100,
        getTitle: (item) => item.fullName,
        editor: (props) => <MoveStaffToSupplier pdfType='bidHistory' {...props} />,
        prepareForEdit: (parent, item) => {
            return { ...parent, id: parent.aspNetUserId, password: '', checkPassword: '', phoneNumber: item.departmentPhone }
        }
    },
    messageLog: {
        name: 'MessageLog',
        plural: 'Messages',
        title: 'Message',
        getSingle: endpoints.getMessage,
        showDates: true,
        itemParam: 'messageId',
        saveSingle: endpoints.updateMessage,
        getTitle: (x) => {
            return x.entityType + x.fromState + '⮕' + x.newState + "\n" + x.subject
        },
        defaultStatus: 'Active',
        heightOffset: 200,
        columns: [
            {
                accessor: (x) => x.createdAt,
                Cell: ({ row }) => showDateUTC(row.original.createdAt) + '\n' + showTimeUTC(row.original.createdAt),
                Header: 'Created'
            },
            {
                accessor: 'name', Header: 'Name',
                sortNoCase: true,
            },

            {
                accessor: 'toEmail',
                Header: 'To',
                sortNoCase: true,
            },
            {
                accessor: (x) => x.fromState + x.newState,
                render: ({ row }) => <Container><Row>{row.original.entityType} </Row><Row>{row.original.fromState + '⮕' + row.original.newState}</Row > </Container>, Header: 'About'
            },
            { accessor: 'targetAudience', Header: 'Audience' },
            { accessor: 'status', Header: 'Status' }
        ],
        editor: (props) => <ViewMessageLogItem {...props} />

    },
    supplier: {
        name: 'Supplier',
        title: 'Supplier',
        plural: 'Suppliers',
        params: ['activeKey', 'supplierId'],
        getSingle: endpoints.getSupplier,
        addSingle: endpoints.addSupplier,
        hideNew: true,
        saveSingle: endpoints.updateSupplier,
        getByStatus: ({ status, name }) => endpoints.getSupplierByStatus + status,
        getAll: () => endpoints.getAllSuppliers,
        itemParam: 'supplierId',
        childParam: 'itemId',
        getTitle: (supplierDetail) => <UserStatus supplier={supplierDetail}> {supplierDetail?.companyName} </UserStatus>,
        defaultStatus: 'Active',
        columns: [
            {
                accessor: 'companyName', Header: 'Company Name',
                Cell: ({ row }) => <UserStatus supplier={row.original} > {row.original.companyName} </UserStatus>,
                sortNoCase: true,
            },
            {
                accessor: 'fullName', Header: 'Name',
                sortNoCase: true,
            },
            { accessor: 'companyPhone', Header: 'Phone' },
            {
                accessor: 'email', Header: 'Email', sortNoCase: true,
            },
            { accessor: 'status', Header: 'Status' },
        ], newItem: () => {
            return {
                companyName: "",
                companyAddress: "",
                companyPhone: "",
                firstName: "",
                lastName: "",
                email: "",
                status: "",
                directDebit: 0,
                complianceTypes: "",
                preferred: false,
                clientTypes: "Generic",
                charterTypes: "",
                confirmedDate: '1990-10-10T12:00:00',
                billingDueDate: '1990-10-10T12:00:00',
                aocNumber: "",
                aocIssuedDate: null,
                part138Number: "",
                part138IssuedDate: null
            }
        },
        editor: (props) => {
            return <EditSupplier {...props} />
        },
        validationSchema: supplierShapeYup

    },
    client: {
        name: 'Client',
        plural: 'Clients',
        title: 'Client',
        getSingle: endpoints.getClient,
        saveSingle: endpoints.updateClient,
        addSingle: endpoints.addClient,
        itemParam: 'clientId',
        hideNew: true,
        childParam: 'clientDepartmentId',
        getByStatus: ({ status }) => endpoints.getClientsByStatus + status,
        getTitle: (clientDetail) => <UserStatus client={clientDetail}> {clientDetail?.companyName} </UserStatus>,
        defaultStatus: 'Active',
        columns: [
            {
                accessor: 'companyName', Header: 'Company Name',
                Cell: ({ row }) => <UserStatus client={row.original} > <b>{row.original.companyName} </b></UserStatus >,
                sortNoCase: true,

            },
            {
                accessor: 'fullName', Header: 'Name',
                sortNoCase: true,
            },
            {
                accessor: 'companyPhone', Header: 'Phone',
            },
            {
                accessor: 'email', Header: 'Email',
                sortNoCase: true,
            },
            { accessor: 'status', Header: 'Status' },
        ],
        newItem: ({ status }) => {
            return {
                companyName: "",
                companyAddress: "",
                companyPhone: "",
                firstName: "",
                lastName: "",
                email: "",
                notesForSupplier: "",
                emailDomain: "",
                canViewSupplierInfo: true,
                hidePrice: true,
                clientType: "",
                marginType: "",
                status: status
            }
        },
        editor: (props) => <ClientEditor {...props} />,
        validationSchema: clientShapeYup
    },
    aircraftImageList: {
        name: 'AircraftImage',
        plural: 'Aircraft Images',
        title: 'Aircraft Image',
        getSingle: endpoints.getAircraftImage,
        addSingle: endpoints.addAircraftImage,
        itemParam: 'imageId',
        getByStatus: ({ id }) => {
            return endpoints.getAircraftImages + '/' + id;
        },
        getTitle: (detail) => {
            return detail && detail.licenseNumber ? detail.licenseNumber + '-' + detail?.type : "New Aircraft Image"
        },
        defaultStatus: 'Active',
        heightOffset: 100,
        newItem: ({ id, ...props }) => {
            return {
                ...props,
                aircraftId: id,
                category: "",

                contentType: "",
                fileName: "",
                // file (Handed via filename)
                status: "Active"
            }
        },
        editor: (props) => <AircraftImageDetail {...props} />,
        validationSchema: aircraftImageShapeYup
    },
    aircraftImages: {
        name: 'AircraftImages',
        plural: 'Aircraft Images',
        title: 'Aircraft Image',
        getSingle: endpoints.getAircraftImage,
        addSingle: endpoints.addAircraftImage,
        itemParam: 'imageId',
        getByStatus: () => {
            return endpoints.getAircraftImages;
        },
        getTitle: (detail) => {
            return detail && detail.licenseNumber ? detail.licenseNumber + '-' + detail?.type : "New Aircraft Image"
        },
        defaultStatus: 'Active',
        heightOffset: 100,
        newItem: ({ id, ...props }) => {
            return {
                ...props,
                aircraftId: id,
                category: "",

                contentType: "",
                fileName: "",
                // file (Handed via filename)
                status: "Active"
            }
        },
        editor: (props) => <AircraftImageDetail {...props} />,
        validationSchema: aircraftImageShapeYup
    },
    aircraft: {
        name: 'AircraftInventory',
        plural: 'Aircraft',
        title: 'Aircraft',
        getSingle: endpoints.getAircraft,
        saveSingle: endpoints.updateAircraft,
        addSingle: endpoints.addAircraft,
        itemParam: 'itemId',
        hideNew: true,
        getTitle: (detail) => {
            return detail?.licenseNumber ? detail?.licenseNumber + '-' + detail?.type : "New Aircraft"
        },
        defaultStatus: 'Active',
        heightOffset: 50,
        columns: [
            { accessor: 'licenseNumber', Header: 'Licence' },
            { accessor: 'passengerLimit', Header: 'Passegers' },
            { accessor: 'type', Header: 'Make and Model' },
            { accessor: 'status', Header: 'Status' },
        ],
        editor: (props) => <AircraftDetail {...props} />,

        validationSchema: aircraftShapeYup
    },
    supplierDocument: {
        type: null as unknown as ISupplierDocument[] | null,
        name: 'SupplierDocument',
        title: 'Supplier Document',
        plural: 'Supplier Documents',
        getSingle: endpoints.getSupplierDocument,
        saveSingle: endpoints.updateSupplierDocument,
        getByStatus: ({ id, status }) => endpoints.getSupplierDocumentByStatus + id + '/' + status,
        getTitle: (supplierDetail) => {
            return supplierDetail?.companyName
        },
        hideViewButton: true,
        hideStatus: true,
        hideActions: true,
        parentParam: 'supplierId',
        defaultStatus: 'Active',
        columns: [{ accessor: (x) => <DocumentDetails doc={x} />, Header: 'Details' }],

    },
     supplierInsuranceDocuments: {
        type: null as unknown as ISupplierDocument[] | null,
        name: 'supplierInsuranceDocument',
        title: 'supplier Insurance Documents',
        plural: 'supplier Insurance Documents',
        getSingle: endpoints.getSupplierDocument,
        saveSingle: endpoints.updateSupplierDocument,
        getByStatus: ({ id, status }) => endpoints.getSupplierInsuranceDocuments + id + '/' + status,
        getTitle: (supplierDetail) => {
            return supplierDetail?.companyName
        },
        hideViewButton: true,
        hideStatus: true,
        hideActions: true,
        parentParam: 'supplierId',
        defaultStatus: 'Active',
        columns: [{ accessor: (x) => <DocumentDetails doc={x} />, Header: 'Details' }],

    },
    supplierSecondaryEmails: {
        name: 'SupplierSecondaryEmails',
        title: 'Secondary Email',
        plural: 'Secondary Emails',
        hideStatus: true,
        hideActions: true,
        parentParam: 'supplierId',
        hideViewButton: true,
        defaultStatus: 'Active',
        getBySupplier: ({ id }) => endpoints.getSupplierSecondaryEmails + id,
        addSingle: endpoints.addSecondaryEmail,
        removeSingle: endpoints.removeSecondaryEmail,
        editor: (props) => <SecondaryEmails {...props} />,
    },
    notCheckedDocuments: {
        name: 'SupplierDocument',
        title: 'Supplier Document',
        plural: 'Supplier Documents',
        getByStatus: () => endpoints.getUnCheckedDocuments,
        getTitle: (supplierDetail) => {
            return supplierDetail?.companyName
        },
        hideStatus: true,
        hideActions: true,
        parentParam: 'supplierId',

        hideViewButton: true,
        defaultStatus: 'Active',
        columns: ({ route }) => [

            {
                accessor: (x) => x.supplier.companyName,
                Cell: ({ row }) => {
                    return <DocumentDetails index={row.index} route={route} doc={row.original} supplierId={row.original.supplierId} />
                },
                Header: 'Details'
            },
        ],
        prepareForEdit: (x) => {
            let { supplierId, ...rest } = x;
            rest.id = supplierId;
            return rest;
        }

    },
    supplierOptionalDocument: {
        type: null as null | ISupplierDocument[],
        name: 'SupplierDocument',
        title: 'Supplier Document',
        plural: 'Supplier Documents',
        getSingle: endpoints.getSupplierDocument,
        saveSingle: endpoints.updateSupplierDocument,
        getByStatus: ({ id, status }) => endpoints.getSupplierOptionalDocuments + id + '/' + status,
        getTitle: (supplierDetail) => {
            return supplierDetail?.companyName
        },
        hideStatus: true,
        hideActions: true,
        parentParam: 'supplierId',
        defaultStatus: 'Active',
        columns: [
            { accessor: 'fileCategory', Header: 'FileCategory' },
            { accessor: (x) => <DocumentDetails doc={x} />, Header: 'Details' },
        ],

    },
    admins: {
        name: 'Admins',
        plural: 'Administrators',
        title: 'Administrator',
        getSingle: endpoints.getAdmin,
        saveSingle: endpoints.updateAdmin,
        addSingle: endpoints.addAdmin,
        itemParam: 'adminId',
        hideNew: true,
        getByStatus: ({ status }) => endpoints.getAllAdmins + status,
        getTitle: (detail) => {
            return detail?.fullName
        },

        defaultStatus: 'Active',
        columns: [
            {
                accessor: 'fullName', Header: 'Name',
                sortNoCase: true,
            },

            { accessor: 'companyPhone', Header: 'Phone' },
            {
                accessor: 'email', Header: 'Email', sortNoCase: true,
            },
            { accessor: 'status', Header: 'Status' },
        ],
        newItem: ({ status }) => {
            return {
                firstName: "",
                lastName: "",
                email: "",
                status: status,
                invited: true,
            }
        },
        editor: (props) => <AdminDetail invite={props.isNewItem} {...props} />
        ,
        validationSchema: adminShapeYup
    },
    charterAdmins: {
        name: 'CharterAdmin',
        plural: 'Charter Administrators',
        title: 'Charter Administrator',
        getSingle: endpoints.getCharterAdmin,
        saveSingle: endpoints.updateCharterAdmin,
        addSingle: endpoints.addCharterAdmin,
        itemParam: 'adminId',
        hideNew: true,
        getByStatus: ({ status }) => endpoints.getAllCharterAdmins + status,
        getTitle: (detail) => {
            return detail?.fullName
        },

        defaultStatus: 'Active',
        columns: [
            {
                accessor: 'fullName', Header: 'Name',
                sortNoCase: true,
            },

            { accessor: 'companyPhone', Header: 'Phone' },
            {
                accessor: 'email', Header: 'Email', sortNoCase: true,
            },
            { accessor: 'status', Header: 'Status' },
        ],
        newItem: ({ status }) => {
            return {
                firstName: "",
                lastName: "",
                email: "",
                companyName: "",
                companyPhone: "",
                companyAddress: "",
                status: status,
                invited: true,
            }
        },
        editor: (props) => <CharterAdminDetail invite={props.isNewItem} {...props} />
        ,
        validationSchema: adminShapeYup
    },
    clientDepartment: {
        name: 'ClientDepartment',
        plural: 'Client Departments',
        title: 'Client Department',
        getSingle: endpoints.getClientDepartment,
        saveSingle: endpoints.updateClientDepartment,
        itemParam: 'clientDepartmentId',
        getByStatus: ({ id, status }) => endpoints.getClientDepartmentsForClientByStatus + id + '/' + status,
        getTitle: (detail) => <UserStatus client={detail.client}> {detail?.departmentName} </UserStatus>,

        defaultStatus: 'Active',
        hideNew: true,
        columns: [
            {
                accessor: 'departmentName', Header: 'Department Name',
                Cell: ({ row }) => <UserStatus client={row.original.client} > {row.original.departmentName} </UserStatus>,
                sortNoCase: true,

            },
            {
                accessor: 'fullName'
                , Header: 'Name'
                , sortNoCase: true,
            },
            {
                accessor: 'email', Header: 'Email', sortNoCase: true,
            },
            {
                accessor: 'status', Header: 'Status', sortNoCase: true,
            },
        ],
        addSingle: endpoints.addClientDepartment,
        newItem: ({ status, ...item }) => {
            return {
                clientMasterId: item?.id,
                firstName: "",
                lastName: "",
                email: "",
                notesForSupplier: '',
                emailDomain: '',
                canViewSupplierInfo: true,
                hidePrice: true,
                marginType: '',
                client: item,
                status: status,
            }
        },
        saveMessage: (item) => {
            if (item.id) {
                return 'Saved ' + item.fullName;
            }
            else {
                return 'Thanks - We have sent an invitiation email to ' + item.email;
            }
        },
        heightOffset: 100,
        editor: (props) => <ClientDepartmentEditor {...props} />,
        validationSchema: clientDepartmentShapeYup
    },
    clientDepartmentAdmin: {
        name: 'ClientDepartment',
        plural: 'Client Departments',
        title: 'Client Department',
        getSingle: endpoints.getClientDepartment,
        saveSingle: endpoints.updateClientDepartment,
        itemParam: 'clientId',
        childParam: 'clientStaffId',
        getByStatus: ({ status }) => endpoints.getAllClientDepartments + status,
        getAll: () => endpoints.getAllClientDepartments,
        getTitle: (detail) => <UserStatus client={detail.client}> {detail?.departmentName} </UserStatus>,
        hideNew: true,
        defaultStatus: 'Active',
        hideActions: true,
        columns: [
            {
                accessor: (x) => {
                    return x.client?.companyName + x.clientDepartment?.departmentName
                },
                Header: 'Company Name',
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original.client.companyName} </b></Row >
                        <Row>{row.original.departmentName} </Row></Container >
                </UserStatus>,
            },
            { accessor: 'fullName', Header: 'Name' },
            { accessor: 'email', Header: 'Email' },
            { accessor: 'status', Header: 'Status' },
        ],
        addSingle: endpoints.addClientDepartment,
        newItem: ({ status, ...item }) => {
            return {
                clientMasterId: item?.id,
                firstName: "",
                lastName: "",
                email: "",
                notesForSupplier: '',
                emailDomain: '',
                canViewSupplierInfo: true,
                hidePrice: true,
                marginType: '',
                client: item,
                status: status,
            }
        },
        saveMessage: (item) => {
            if (item.id) {
                return 'Saved ' + item.fullName;
            }
            else {
                return 'Thanks - We have sent an invitiation email to ' + item.email;
            }
        },
        editor: (props) => <ClientDepartmentEditor {...props} />,
        heightOffset: 100,
        validationSchema: clientDepartmentShapeYup
    },
    clientStaff: {

        name: 'ClientStaff',
        plural: 'Client Staff',
        title: 'Client Staff',
        getSingle: endpoints.getClientStaff,
        saveSingle: endpoints.updateClientStaff,
        addSingle: endpoints.addClientStaff,
        hideNew: true,
        itemParam: 'clientStaffId',

        getByStatus: ({ id, status }) => endpoints.getClientStaffForDepartment + id + '/' + status,
        getTitle: (detail) => <UserStatus client={detail.client}> {detail?.fullName} </UserStatus>,
        editor: (props) => <ClientStaffDetail {...props} />
        ,
        defaultStatus: 'Active',
        heightOffset: 200,
        columns: [
            {
                accessor: 'clientDepartment.departmentName', Header: 'Department Name',
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original.clientDepartment?.departmentName} </b></Row >
                        <Row>{row.original.clientDepartment?.departmentName} </Row></Container >
                </UserStatus>,

            },
            { accessor: 'fullName', Header: 'Name' },
            { accessor: 'email', Header: 'Email' },
            { accessor: 'status', Header: 'Status' },
        ],
        saveMessage: (item) => {
            if (item.id) {
                return 'Saved ' + item.fullName;
            }
            else {
                return 'Thanks - We have sent an invitiation email to ' + item.email;
            }
        },
        newItem: ({ ...item }) => {
            return {
                clientMasterId: item?.id,
                firstName: "",
                lastName: "",
                email: "",
            }
        },
        validationSchema: clientStaffShapeYup
    },
    clientStaffClient: {

        name: 'ClientStaff',
        plural: 'Client Staff',
        title: 'Client Staff',
        getSingle: endpoints.getClientStaff,
        saveSingle: endpoints.updateClientStaff,
        addSingle: endpoints.addClientStaff,
        hideNew: true,
        itemParam: 'clientStaffId',

        getByStatus: ({ id, status }) => endpoints.getClientStaffForClient + id + '/' + status,
        getTitle: (detail) => <UserStatus client={detail.client}> {detail?.fullName} </UserStatus>,

        defaultStatus: 'Active',
        heightOffset: 200,
        columns: [
            {
                accessor: 'client.companyName', Header: 'Client / Department',
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original.client.companyName} </b></Row >
                        <Row>{row.original.clientDepartment?.departmentName} </Row></Container >
                </UserStatus>,
            },
            { accessor: 'fullName', Header: 'Name' },
            { accessor: 'email', Header: 'Email' },
            { accessor: 'status', Header: 'Status' },
        ],
        editor: (props) => <ClientStaffEditor {...props} />
        ,
        saveMessage: (item) => {
            if (item.id) {
                return 'Saved ' + item.fullName;
            }
            else {
                return 'Thanks - We have sent an invitiation email to ' + item.email;
            }
        },
        validationSchema: clientStaffShapeYup
    },
    clientStaffAdmin: {

        name: 'ClientStaff',
        plural: 'Client Staff',
        title: 'Client Staff',
        getSingle: endpoints.getClientStaff,
        saveSingle: endpoints.updateClientStaff,
        addSingle: endpoints.addClientStaff,
        hideNew: true,
        itemParam: 'clientStaffId',

        getByStatus: ({ id, status }) => endpoints.getAllClientStaff + status,
        getTitle: (detail) => <UserStatus client={detail.client}> {detail?.fullName} </UserStatus>,

        defaultStatus: 'Active',
        heightOffset: 200,
        columns: [
            {
                accessor: (x) => {
                    return x.client?.companyName + x.clientDepartment?.departmentName
                },
                Header: 'Client/Department',
                Cell: ({ row }) => <UserStatus client={row.original.client} >
                    <Container><Row><b>{row.original.client.companyName} </b></Row >
                        <Row>{row.original.clientDepartment?.departmentName} </Row></Container >
                </UserStatus>,
            },
            { accessor: 'fullName', Header: 'Name' },
            { accessor: 'email', Header: 'Email' },
            { accessor: 'status', Header: 'Status' },
        ],
        editor: (props) => <ClientStaffEditor {...props} />,
        saveMessage: (item) => {
            if (item.id) {
                return 'Saved ' + item.fullName;
            }
            else {
                return 'Thanks - We have sent an invitiation email to ' + item.email;
            }
        },
        validationSchema: clientStaffShapeYup
    },
    marginDetails: {
        name: 'Margins',
        plural: 'Margins',
        title: 'Margins',
        getSingle: endpoints.getMarginDetails,
        getTitle: () => 'Margins',
        addSingle: endpoints.updateMarginDetails,
        itemParam: 'clientId',
        defaultStatus: 'Active',
        editor: (props) => <MarginEditor {...props} />,
        beforeSave: (results) => {
            const { marginItems, ...rest } = results;
            const newMargin = marginItems.map(x => {
                const { usePercent, percentage, price, ...rest } = x;
                return { ...rest, percentage: usePercent ? percentage : 0, price: usePercent ? 0 : price }
            })
            return { ...rest, marginItems: newMargin };
        },
        saveMessage: (charter) => <h3>Margins Updated! </h3>
        ,

    },
    allowedAction: {
        name: 'AllowedActions',
        plural: 'Allowed Actions',
        title: 'Allowed Action',
        getSingle: endpoints.getAllowedAction,
        saveSingle: endpoints.updateAllowedAction,
        removeSingle: endpoints.deleteAllowedAction,
        addSingle: endpoints.addAllowedAction,
        getByStatus: null,
        getTitle: (allowedAction) => {
            return allowedAction.entityType + ' ' + allowedAction.entityState + ' => ' + allowedAction.nextState

        },
        defaultStatus: 'Active',
        columns: [],
        editor: (props) => <AllowedActionDetail {...props} />,
        validationSchema: allowedActionsShapeYup
    },
    stateChangeEvent: {
        name: 'StateChangeEvent',
        plural: 'State Change Events',
        title: 'State Change Event',
        getSingle: endpoints.getStateChangeEvent,
        saveSingle: endpoints.updateStateChangeEvent,
        removeSingle: endpoints.deleteStateChangeEvent,
        addSingle: endpoints.addStateChangeEvent,
        getByStatus: ({ type }) => {
            return endpoints.getActionsForUser + type
        },
        getTitle: (allowedAction) => {
            return allowedAction.entityType + ' ' + allowedAction.fromState + ' => ' + allowedAction.newState
        },
        defaultStatus: 'Active',
        columns: [],
        editor: (props) => <StateChangeEventDetail {...props} />,
        validationSchema: null
    },

}

export default entities;